import React from "react";
import { Link } from "react-router-dom";
import {
    FaPhoneAlt, FaEnvelope, FaWhatsapp, FaGlobe
} from "react-icons/fa";
import { buildWhatsAppUrl } from "../../utils/whatsapp";

const PublicFooter = () => {
    return (
        <footer className="bg-[#F7F5EF] border-t border-[#E5E7EB] pt-14 pb-10 text-[#687482] text-xs font-sans">
            <div className="max-w-[1400px] mx-auto px-4 sm:px-6 lg:px-8">
                {/* 4-Column Balanced Grid */}
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-12 gap-8 lg:gap-10 mb-12">

                    {/* Column 1: Brand, Address & Contact (Spans 5 Columns) */}
                    <div className="lg:col-span-5 space-y-4">
                        <div className="space-y-2">
                            <Link to="/" className="inline-block group">
                                <img
                                    src="/logo.png"
                                    alt="LUMIGO Projection Solutions"
                                    className="h-11 w-auto object-contain hover:opacity-95 transition"
                                />
                            </Link>
                            <div className="flex items-center gap-2 text-xs font-bold text-[#263746]">
                                <img
                                    src="/favicon.png"
                                    alt="LUMIGO Aperture"
                                    className="w-4 h-4 object-contain"
                                />
                                <span className="tracking-wide">Commercial Gobo Projection Solutions</span>
                            </div>
                        </div>

                        <div className="text-xs leading-relaxed text-[#263746] max-w-sm">
                            <strong className="text-sm font-bold block mb-0.5">Fourlifters Private Limited</strong>
                            <p className="text-[#687482]">
                                E-21/22, Kaygee Engineering Premises, T Block, MIDC Bhosari, Pune, Maharashtra, India - 411026
                            </p>
                        </div>

                        <div className="space-y-2 pt-1 text-xs">
                            <div className="flex items-center gap-2 text-[#263746]">
                                <FaPhoneAlt className="text-[#E3B629] text-xs flex-shrink-0" />
                                <a href="tel:+918087680893" className="hover:underline font-bold">+91 8087680893</a>
                            </div>

                            <div className="flex items-center gap-2 text-[#263746]">
                                <FaEnvelope className="text-[#E3B629] text-xs flex-shrink-0" />
                                <a href="mailto:fourlifters@gmail.com" className="hover:underline">fourlifters@gmail.com</a>
                                <span className="text-[#9CA3AF]">/</span>
                                <a href="mailto:sales@fourlifters.in" className="hover:underline">sales@fourlifters.in</a>
                            </div>

                            <div className="flex items-center gap-2 text-[#263746]">
                                <FaWhatsapp className="text-[#168B53] text-sm flex-shrink-0" />
                                <a
                                    href={buildWhatsAppUrl("Hello Fourlifters / LUMIGO team, I would like to inquire about gobo projectors.")}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="hover:underline font-bold text-[#168B53]"
                                >
                                    +91 8087680893 (WhatsApp Support)
                                </a>
                            </div>

                            <div className="flex items-center gap-2 text-[#263746]">
                                <FaGlobe className="text-[#E3B629] text-xs flex-shrink-0" />
                                <a href="https://www.fourlifters.in" target="_blank" rel="noopener noreferrer" className="hover:underline font-medium">
                                    www.fourlifters.in
                                </a>
                            </div>

                            <div className="text-[11px] text-[#687482] pt-1">
                                GST NO.: <span className="font-mono font-bold text-[#263746]">27AAECF6202G1ZX</span>
                            </div>
                        </div>
                    </div>

                    {/* Column 2: Hardware Lineup (Spans 2-3 Columns) */}
                    <div className="lg:col-span-2 space-y-3">
                        <h4 className="text-[#263746] font-extrabold uppercase tracking-wider text-xs mb-3 pb-1 border-b border-[#E5E7EB]/80 inline-block">
                            Hardware Lineup
                        </h4>
                        <ul className="space-y-2 text-xs">
                            <li><Link to="/products" className="text-[#687482] hover:text-[#E3B629] transition block">Outdoor Projectors (IP65)</Link></li>
                            <li><Link to="/products" className="text-[#687482] hover:text-[#E3B629] transition block">Indoor Commercial Units</Link></li>
                            <li><Link to="/products" className="text-[#687482] hover:text-[#E3B629] transition block">Dynamic Rotating Gobos</Link></li>
                            <li><Link to="/products" className="text-[#687482] hover:text-[#E3B629] transition block">Custom Dichroic Glass Gobos</Link></li>
                            <li><Link to="/products" className="text-[#687482] hover:text-[#E3B629] transition block">High-Wattage Facade Projectors</Link></li>
                        </ul>
                    </div>

                    {/* Column 3: Applications & About (Spans 3 Columns) */}
                    <div className="lg:col-span-3 space-y-3">
                        <h4 className="text-[#263746] font-extrabold uppercase tracking-wider text-xs mb-3 pb-1 border-b border-[#E5E7EB]/80 inline-block">
                            Applications & About
                        </h4>
                        <ul className="space-y-2 text-xs">
                            <li><Link to="/applications" className="text-[#687482] hover:text-[#E3B629] transition block">Industrial Safety Walkways</Link></li>
                            <li><Link to="/applications" className="text-[#687482] hover:text-[#E3B629] transition block">Hotel & Retail Facades</Link></li>
                            <li><Link to="/about" className="text-[#687482] hover:text-[#E3B629] transition block">About Fourlifters</Link></li>
                            <li><Link to="/gallery" className="text-[#687482] hover:text-[#E3B629] transition block">Installation Gallery & Videos</Link></li>
                            <li><Link to="/contact" className="text-[#687482] hover:text-[#E3B629] transition block">Contact & Enquiries</Link></li>
                        </ul>
                    </div>

                    {/* Column 4: Policies & Trust (Spans 2 Columns) */}
                    <div className="lg:col-span-2 space-y-3">
                        <h4 className="text-[#263746] font-extrabold uppercase tracking-wider text-xs mb-3 pb-1 border-b border-[#E5E7EB]/80 inline-block">
                            Policies & Trust
                        </h4>
                        <ul className="space-y-2 text-xs">
                            <li><Link to="/terms" className="text-[#687482] hover:text-[#E3B629] transition block">Terms & Conditions</Link></li>
                            <li><Link to="/privacy" className="text-[#687482] hover:text-[#E3B629] transition block">Privacy Policy</Link></li>
                            <li><Link to="/shipping-policy" className="text-[#687482] hover:text-[#E3B629] transition block">Shipping Policy</Link></li>
                            <li><Link to="/refund-policy" className="text-[#687482] hover:text-[#E3B629] transition block">Returns & Refunds</Link></li>
                            <li><Link to="/warranty" className="text-[#687482] hover:text-[#E3B629] transition block">Warranty Policy</Link></li>
                        </ul>
                    </div>

                </div>

                {/* Subfooter Row */}
                <div className="border-t border-[#E5E7EB] pt-6 flex flex-col sm:flex-row items-center justify-between text-[11px] text-[#687482] gap-3 text-center sm:text-left">
                    <p>&copy; {new Date().getFullYear()} LUMIGO. By Fourlifters Private Limited. All Rights Reserved.</p>
                    <p className="text-center sm:text-right tracking-wide">
                        YOUR BRAND. IN LIGHT. Commercial Gobo Projection Systems & Optical Solutions.
                    </p>
                </div>
            </div>
        </footer>
    );
};

export default PublicFooter;
